import { FC } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

export const PanelContentContainer: FC<FlexProps> = ({
  children,
  ...props
}) => {
  return (
    <Flex justify="center" overflow="hidden" w="full">
      <Flex
        direction="column"
        gap={6}
        pt={{ base: 8, md: 16 }}
        w="full"
        {...props}
      >
        {children}
      </Flex>
    </Flex>
  );
};
